export default "__VITE_ASSET__CryAWrfh__"